import React from 'react';

import * as S from './styles';

interface DefaultModalProps {
  children: any;
  setModalVisible: (modalVisible: boolean) => void;
  modalVisible: boolean;
  onClose?: () => void;
}

export default function DefaultModal({
  children,
  modalVisible,
  setModalVisible,
  onClose,
}: DefaultModalProps) {
  const handleBackdropPress = () => {
    setModalVisible(false);
    onClose ? onClose() : null;
  };
  return (
    // @ts-ignore
    <S.ModalArea isVisible={modalVisible} onBackdropPress={handleBackdropPress}>
      {children}
    </S.ModalArea>
  );
}
